export default __webpack_public_path__ + "static/media/logo-nasa.8859e3d6.svg";